// Package Imports

// import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslate } from '@refinedev/core';

// Package Imports

import { getFormattedDate } from 'core/utils/getDataValue';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  // InfoCircleOutlined,
} from '@ant-design/icons';
import { useSocketNotificationContext } from 'contexts/resource/socketNotificationContext/SocketNotificationContext';
import ConfigStyle from 'core/constants/ConfigStyle';

const Notification = ({
  notificationsVisible,
  setNotificationsVisible,
}: any) => {
  const t = useTranslate();
  const { notificationMessages, setNotificationMessages } =
    useSocketNotificationContext();
  const [showReadMsg, setShowReadMsg] = useState(true);
  const [filteredNotificationMsgs, setFilteredNotificationMsgs] =
    useState(notificationMessages);
  const handleClear = () => {
    setNotificationMessages([]);
    if (localStorage.getItem('notifications') !== null) {
      localStorage.removeItem('notifications');
    }
  };
  const handleClose = () => {
    const updatedNotificationMsg = notificationMessages?.map((message) => ({
      ...message,
      read: true,
    }));
    setNotificationMessages(updatedNotificationMsg);
    localStorage.setItem(
      'notifications',
      JSON.stringify(updatedNotificationMsg)
    );
    setNotificationsVisible(false);
  };
  function handleMsgToggle() {
    setShowReadMsg((prev) => !prev);
  }
  useEffect(() => {
    if (notificationMessages) {
      if (showReadMsg) {
        setFilteredNotificationMsgs(notificationMessages); // all msgs read+unread
      } else {
        const unreadMsgs =
          notificationMessages?.filter((msg) => !msg?.read) || []; // only unread msgs i.e read=false
        setFilteredNotificationMsgs(unreadMsgs);
      }
    }
  }, [showReadMsg, notificationMessages]);
  useEffect(() => {
    if (notificationsVisible) {
      setShowReadMsg(true);
    }
  }, [notificationsVisible]);

  function getStatusClassName(status) {
    switch (status) {
      case 'success':
        return ConfigStyle.colors['success-50'];
      case 'failed':
        return ConfigStyle.colors['danger-50'];
      case 'in-progress':
        return ConfigStyle.colors['info-50'];
      case 'started':
        return 'bg-neutral-20';
      default:
        return '';
    }
  }
  function getStatusBorderColor(status) {
    switch (status) {
      case 'success':
        return ConfigStyle.colors['success-500'];
      case 'failed':
        return ConfigStyle.colors['danger-500'];
      case 'in-progress':
        return ConfigStyle.colors['info-500'];
      case 'started':
        return ConfigStyle.colors['neutral-300'];
      default:
        return ConfigStyle.colors.black;
    }
  }
  const getStatusIcon = (status) => {
    if (status === 'success') {
      return <CheckCircleOutlined className="text-success-400 text-lg" />;
    }
    if (status === 'failed') {
      return <ExclamationCircleOutlined className="text-danger-500 text-lg" />;
    }
    return <InfoCircleOutlined className="text-primary-500 text-lg" />;
  };

  return notificationsVisible ? (
    <div
      className="fixed top-[64px] p-lg bg-neutral-10 drop-shadow-lg rounded-lg flex w-screen max-w-max -translate-x-1/2 notification"
      style={{
        // backgroundColor: '#f0f0f0',
        boxShadow:
          'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
      }}
    >
      <div className="notification-arrow" />
      <div className="w-screen max-w-md flex-auto  text-sm leading-6 shadow-lg ring-2 ring-neutral-700/6 bg-gradient-to-r from-neutral-20 to-primary-50">
        {/* <div> */}
        {/* show all msgs initially */}
        <span className="text-neutral-10 bg-primary-400 px-sm py-xs rounded-md font-semibold">
          All{' '}
          <span className="bg-neutral-10 text-neutral-900 px-xs rounded-md ml-xs">
            {filteredNotificationMsgs?.length}
          </span>
        </span>
        <div className="mt-md mb-md">
          {' '}
          <span className="text-neutral-900 text-base">
            {t('pages.socketNotification.readUnreadMsg')}
          </span>
          <Switch defaultChecked onChange={handleMsgToggle} className="mx-sm" />
        </div>
        {filteredNotificationMsgs && filteredNotificationMsgs?.length > 0 ? (
          <div className="overflow-y-auto max-h-[600px] p-xs">
            {filteredNotificationMsgs?.map((item, msgindex) => (
              <div
                key={msgindex}
                className="group gap-x-lg p-md mb-md rounded-lg"
                style={{
                  border: '2px solid',
                  borderColor: getStatusBorderColor(item?.status),
                  backgroundColor: getStatusClassName(item?.status),
                }}
              >
                <div className="flex items-center space-x-5">
                  <div className="">
                    {/* {isSuccess ? (
                        <CheckCircleOutlined className='text-green-500 text-lg' /> 
                      ):  (<ExclamationCircleOutlined className='text-red-500 h-8 w-8' />) } */}
                    {getStatusIcon(item?.status)}
                  </div>

                  <div className="w-full">
                    <div className="flex items-center justify-between">
                      <p className="mb-0 text-sm">{item?.title}</p>

                      <div className="text-xs text-neutral-90 text-end">
                        {getFormattedDate(item?.timestamp)}
                      </div>
                    </div>
                    <p className="mt-xs mb-0 text-neutral-600 font-semibold text-sm">
                      {item?.message}
                    </p>
                  </div>
                </div>
                {/* <div className="flex items-center gap-x-6">

                    <div className="">
                      {isSuccess ? (
                        <CheckCircleOutlined className='text-green-500 text-lg' /> 
                      ):  (<ExclamationCircleOutlined className='text-red-500 h-8 w-8' />) }
                    </div>

                    <div className='flex gap-x-8 items-center'>
                      {item?.title}{' '}
                      <span className="text-xs text-gray-400 text-end">
                        {getFormattedDate(item?.timestamp)}
                      </span>
                    </div>

                  </div> */}
                {item?.extraKeys
                  ? Object.keys(item?.extraKeys)?.map((objectKey, index) => (
                      <p key={index}>
                        <span className="text-neutral-400">{objectKey}</span>:{' '}
                        {item?.extraKeys[objectKey]}
                      </p>
                    ))
                  : null}
              </div>
            ))}
          </div>
        ) : null}

        <div className="grid grid-cols-2 gap-lg mt-xs">
          <button
            className="flex border-0 rounded-lg items-center justify-center gap-x-sm p-xs font-semibold bg-primary-500 hover:bg-primary-400 hover:text-neutral-10 text-neutral-10 cursor-pointer"
            onClick={handleClear}
          >
            {t('buttons.clear')}
          </button>
          <button
            className="flex rounded-lg items-center justify-center gap-x-sm p-xs font-semibold text-neutral-700 hover:bg-neutral-40 hover:text-neutral-900 cursor-pointer"
            onClick={handleClose}
          >
            {t('buttons.close')}
          </button>
        </div>
      </div>
      {/* </div> */}
    </div>
  ) : null;
};

export default Notification;
